<div class="modal-header">
  <h4 class="modal-title" id="modal-title">
    {{ 'uigexport.dialog.title' | cxTranslate }}
  </h4>
  <button
    type="button"
    class="close"
    aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"
    >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="form-group">
      <div class="form-check d-flex flex-row align-items-center">
        <input
          class="form-check-input"
          type="radio"
          name="exportModeExport"
          id="exportModeExport"
          value="export"
          ng-control="exportModeExport"
          [(ngModel)]="exportMode"
          />
          <label class="form-check-label" for="exportModeExport">
            {{ 'uigexport.dialog.modeExport' | cxTranslate }}
          </label>
          <ng-select
            class="ml-2"
            id="exportType"
            [searchable]="false"
            [clearable]="false"
            [(ngModel)]="selectedExportType"
            >
            @for (type of exportTypes; track type) {
              <ng-option [value]="type">{{
                'uigexport.types.' + type | cxTranslate
              }}</ng-option>
            }
          </ng-select>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="exportModePrint"
            id="exportModePrint"
            value="print"
            ng-control="exportModePrint"
            [(ngModel)]="exportMode"
            />
            <label class="form-check-label" for="exportModePrint">
              {{ 'uigexport.dialog.modePrint' | cxTranslate }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        (click)="modal.dismiss('cancel click')"
        >
        {{ 'common.cancel' | cxTranslate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmit()"
        >
        {{ 'common.submit' | cxTranslate }}
      </button>
    </div>
